import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import usePage from '../../hooks/usePage'
import { FlexColumn } from '../../components/atoms/layout/Flex'
import Table from '../../components/atoms/display/Table'
import TableRow from '../../components/atoms/display/TableRow'
import TableCell from '../../components/atoms/display/TableCell'
import { CompanyActions } from '../../store/company'
import { CompanySelectors } from '../../store/company/selectors'
import { CompanyRepresentative } from '../../types/Company'
import useDay from '../../hooks/useDay'
import useRouter from '../../hooks/useRouter'

function status(representative: CompanyRepresentative) {
  if (representative.rejectedAt !== null) {
    return '却下済み'
  }
  if (representative.submittedAt === null) {
    return '本人確認書類提出待ち'
  }
  if (representative.acceptedAt !== null) {
    return '承認済み'
  }
  return '未承認'
}

export default function AdminRepresentativesPage() {
  const { changeTitle } = usePage()
  const dispatch = useDispatch()
  const representatives = useSelector(CompanySelectors.representatives)
  const { formatDateTime } = useDay()
  const { adminRepresentative } = useRouter()

  useEffect(() => {
    changeTitle('管理', '代表者ユーザー')
    dispatch(CompanyActions.fetchRepresentatives())
  }, [changeTitle, dispatch])

  return (
    <FlexColumn>
      <Table
        header={
          <TableRow>
            <TableCell header>企業名</TableCell>
            <TableCell header size="xs">
              申請日
            </TableCell>
            <TableCell header size="xs">
              ユーザー名
            </TableCell>
            <TableCell header size="xs">
              ステータス
            </TableCell>
          </TableRow>
        }
      >
        {representatives.map((representative) => (
          <TableRow key={representative.id} onClick={() => adminRepresentative(representative.id)}>
            <TableCell align="center">{representative.company.name}</TableCell>
            <TableCell size="xs" align="center">
              {formatDateTime(representative.submittedAt)}
            </TableCell>
            <TableCell size="xs" align="center">
              {representative.user.name}
            </TableCell>
            <TableCell size="xs" align="center">
              {status(representative)}
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </FlexColumn>
  )
}
